module.exports = __webpack_public_path__ + "static/media/pdf-thumbnail_2.png";